<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-grid" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header info-icon-align position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
            <div class="ft-12">{{sourceTimestamp}}</div>
        </div>
        <div class="am-hover-controller position-relative"><img alt="Info"
                src="../../../../assets/images/info-circle.svg">
        </div>
        <!--the hover-pop-->

        <div class="will-appear-on-hover bg-for-popout gap20" id="hover-pop-dover1">

            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Run" src="../../../../assets/images/Run.svg"></div>
                <div>
                    <div class="active">
                        <div class="condition condition-green">Active</div>
                        <div class="condition-value">Above 50%</div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Run" src="../../../../assets/images/exhausted-man.svg"></div>
                <div>
                    <div class="exhausted">
                        <div class="condition condition-yellow">Mildly Active</div>
                        <div class="condition-value">Below 50%</div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center gap20 pop-delivery">
                <div><img alt="Run" src="../../../../assets/images/single-bed.svg"></div>
                <div>
                    <div class="exhausted">
                        <div class="condition condition-red">Inactive</div>
                        <div class="condition-value">Below 5%</div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!--hover pop ends-->
    <div class="d-grid align-items-start grid-display-colum" *ngIf="activityLevelData?.attributeValue">
        <div *ngFor="let donut of activitylevelList; let i = index" class="w-100">
            <div class="d-flex align-items-center justify-content-center position-relative">
                <div class="donut">
                    <app-donut-charts [donutData]="donut" [index]="i"></app-donut-charts>
                </div>
                <div class="position-absolute"><img src="../../../../assets/images/Run.svg"
                        *ngIf="activityLevelData?.attributeValue>=50">
                    <img src="../../../../assets/images/exhausted-man.svg"
                        *ngIf="activityLevelData?.attributeValue<50 && activityLevelData?.attributeValue>5">
                    <img src="../../../../assets/images/single-bed.svg" *ngIf="activityLevelData?.attributeValue<5">
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="d-flex flex-column">
                <div class="value">{{activityLevelData?.attributeValue}}%</div>
                <div class="ft-14 name " [ngClass]="{'condition-green': activityLevelData?.attributeValue>=50,
                    'condition-yellow': +activityLevelData?.attributeValue<50 && +activityLevelData?.attributeValue>5,
                    'condition-red': +activityLevelData?.attributeValue<5 }">{{activityLevelData?.condition}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="!activityLevelData?.attributeValue">No Data Available</div>

    <p *ngIf="isloader || isError">No Data Available</p>